import { combineReducers } from 'redux';
import settings from './settings/reducer';
import compApproverData from './compApproverData/reducers';



const reducers = combineReducers({

  settings,
  compApproverData,
});

export default reducers;